import userInfo, { userInfoSync } from 'hub-http/userInfo';
import { useEffect, useState } from 'react';
const tryUserInfoSync = () => {
  try {
    return userInfoSync();
  } catch (error) {
    return undefined;
  }
};
export const useUserInfo = () => {
  const [userInfoResult, setUserInforResult] = useState(tryUserInfoSync());
  useEffect(() => {
    if (!userInfoResult) {
      userInfo().then(result => {
        setUserInforResult(result);
      }).catch(error => {
        console.error('Failed to fetch user info:', error);
      });
    }
  }, [userInfoResult]);
  return userInfoResult;
};